<div class="modal-header">
  <div class="title">    
      <h2 class="modal-title-prefix">          
        <span *ngIf="_parameters != null && _parameters.count() > 0 && _parameters.get(0).get(0).Value=='I'"> <span translate="DOKUMENT.SINGULAR.PRODAJAEFEKTIVE"></span></span>
        <span *ngIf="_parameters != null && _parameters.count() > 0 && _parameters.get(0).get(0).Value=='U'"> <span translate="DOKUMENT.SINGULAR.OTKUPEFEKTIVE"></span></span>
      </h2>
      <h1 class="modal-title">
          <span translate="DOKUMENTSTAVKE.SINGULAR"></span>
      </h1>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <yt-dokument-stavka-update #baseUpdate></yt-dokument-stavka-update>
</div>
<div class="modal-footer">
  <!-- <button type="submit" class="btn btn-primary" (click)="Save()"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" (click)="Close()"><span>Odustani</span></button> -->
  <button type="submit" class="btn btn-primary" (click)="Save()"><span [innerHTML]="'FW.ACTION.SAVE.ACTION' | translate">Sačuvaj</span></button>  
  <button type="button" class="btn btn-secondary" (click)="Close()"><span [innerHTML]="'FW.ACTION.CANCEL' | translate">Zatvori</span></button>  

</div>